import React from 'react';
import ReactDOM from 'react-dom/client';

// Self-hosted fonts (no Google Fonts network request). Weights match the
// families used in index.css: Fraunces (serif), Work Sans (sans), Space Mono (mono).
import '@fontsource/fraunces/400.css';
import '@fontsource/fraunces/600.css';
import '@fontsource/fraunces/700.css';
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';
import '@fontsource/space-mono/400.css';
import '@fontsource/space-mono/700.css';

import './index.css';
import i18n from './i18n';
import App from './App';
import { parsePublicPath, PUBLIC_PATHS } from './utils/publicLocale';

// --- Public clean-path bootstrap (bilingual SEO / prerendering) ------------
// The marketing pages are served at clean paths (/, /en, /privacy,
// /en/privacy) so crawlers and react-snap get per-locale static HTML. Map that
// clean path to the matching HashRouter route + locale BEFORE React mounts.
//
// This only runs when there is NO hash route yet, so private and email deep
// links (which always arrive as /#/login, /#/reset-password, ...) are never
// touched. Unknown clean paths fall through to the existing home behaviour.
(function bootstrapPublicPath() {
    try {
        if (typeof window === 'undefined') return;
        if (window.location.hash && window.location.hash.length > 1) return; // hash route already present
        const { lang, route } = parsePublicPath(window.location.pathname);
        if (!PUBLIC_PATHS.includes(route)) return; // not a known public page -> leave as-is

        // Force the public locale from the URL, without clobbering the stored
        // preference that the logged-in app relies on (restored right after).
        let stored = null;
        try { stored = localStorage.getItem('i18nextLng'); } catch (e) { /* storage blocked */ }
        if (i18n.language !== lang) i18n.changeLanguage(lang);
        try {
            if (stored) localStorage.setItem('i18nextLng', stored);
            else localStorage.removeItem('i18nextLng');
        } catch (e) { /* storage blocked */ }

        // Point HashRouter at the matching inner route (home needs no hash).
        if (route !== '/') window.location.hash = '#' + route;
    } catch (e) {
        /* never block startup on the SEO bootstrap */
    }
})();

const container = document.getElementById('root');

// react-snap bakes per-locale meta into the static HTML for crawlers, but we do
// NOT hydrate it. Hydrating the prerendered home snapshot on the app's dynamic
// routes (HashRouter login/dashboard, cookie consent) failed to hand control to
// the router — the page stayed stuck on the static home HTML with no click
// handlers. createRoot ignores the snapshot and does a clean client render;
// crawlers still receive the prerendered meta in the initial HTML response.
ReactDOM.createRoot(container).render(<App />);